export default __webpack_public_path__ + "static/media/hero2.4cfc11bb.svg";